import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';
export const getCitiesForUpload = async (network, region) => {
  try {
    const resp = await apiClient.get(`/kmz/upload/cities/?network=${network}&regions=${region}`);

    return resp.data;
  } catch (error) {
    handleApiError(error);
  }
};
